import React from 'react';
import { useParams } from 'react-router-dom';

import SpaceTutorsPageShell from './SpaceTutorsPageShell';

const SchoolTutorPage: React.FC = () => {
  const { city, spaceName } = useParams<{ city: string; spaceName: string }>();
  const resolution =
    city && spaceName ? ({ mode: 'slug', city, spaceName } as const) : null;

  return <SpaceTutorsPageShell resolution={resolution} />;
};

export default SchoolTutorPage;
